// queries/useGetAllInternalModelCategories.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_INTERNAL_MODEL_CATEGORIES } from "api";
import { InternalModelCategories } from "types";

const fetchInternalModelCategories = async (): Promise<InternalModelCategories> => {
  return fetch(`${GET_INTERNAL_MODEL_CATEGORIES}`);
};

export const useGetAllInternalModelCategories = () => {
  return useQuery({
    queryKey: ["internalModelCategories"],
    queryFn: fetchInternalModelCategories,
  });
};

export default useGetAllInternalModelCategories;
